import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import SideMenu from '../components/SideMenu';
import { Plus, Menu } from 'lucide-react';
import { formatDateOnlyIST } from '../utils/dateUtils';

const Approvals = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    loadApprovals();
  }, []);

  const loadApprovals = async () => {
    try {
      const res = await axiosInstance.get('/approvals');
      setApprovals(res.data);
    } catch (err) {
      console.error('Error loading approvals:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50">
      <div className="page-container">
        <div className="page-header">
          <div className="flex items-center gap-3">
            <button 
              onClick={() => setMenuOpen(true)} 
              className="p-2 hover:bg-amber-100 rounded-xl transition-colors"
              data-testid="open-menu-button"
            >
              <Menu className="w-6 h-6 text-gray-700" />
            </button>
            <h1 className="page-title" data-testid="approvals-page-title">Approvals</h1>
          </div>
        </div>

        {user.role !== 'Cashier' && (
          <div className="mb-6">
            <button
              onClick={() => navigate('/approvals/create')}
              className="btn-primary flex items-center gap-2"
              data-testid="create-approval-button"
            >
              <Plus className="w-5 h-5" />
              New Approval
            </button>
          </div>
        )}

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-amber-600 mx-auto"></div>
          </div>
        ) : approvals.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500">No approvals found</p>
          </div>
        ) : (
          <div className="space-y-4 fade-in">
            {approvals.map((approval) => (
              <div
                key={approval.approval_id}
                className="premium-card p-5"
                data-testid={`approval-card-${approval.approval_id}`}
              >
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-lg gold-text">{approval.approval_id}</h3>
                    <p className="text-sm text-gray-600">{formatDateOnlyIST(approval.created_at)}</p>
                  </div>
                  <span className={`status-badge ${
                    approval.status === 'Returned' ? 'status-completed' :
                    approval.status === 'Overdue' ? 'status-overdue' :
                    approval.status === 'Issued' ? 'status-active' :
                    'status-pending'
                  }`}>
                    {approval.status}
                  </span>
                </div>
                <div className="text-sm text-gray-700">
                  <p><strong>Items:</strong> {approval.items.length}</p>
                  <p><strong>Due Date:</strong> {approval.due_back_date}</p>
                  <p><strong>Created by:</strong> {approval.created_by}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <SideMenu user={user} isOpen={menuOpen} onClose={() => setMenuOpen(false)} onLogout={onLogout} />
    </div>
  );
};

export default Approvals;
